import { themeAtom } from "../../../shared/atoms";
import { adminStyles } from "../../styles/admin.styles";
import { HomeIcon } from "@heroicons/react/24/outline";
import { useAtomValue } from "jotai";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";

type Props = {
  isCollapsed: boolean;
};

const AdminSidebarReturnLink = ({ isCollapsed }: Props) => {
  const theme = useAtomValue(themeAtom);

  return (
    <Link
      to="/home"
      title={isCollapsed ? "Return home" : undefined}
      data-test="admin-sidebar-return-link"
      className={twMerge(
        isCollapsed ? adminStyles.sidebar.collapsedReturnLink : adminStyles.sidebar.returnLink,
        theme.sideBarComponent.tailWind.greyscale20,
        theme.myVesselsTableRow.row.hoverTwenty,
      )}
    >
      <HomeIcon className="h-5 w-5 flex-shrink-0" />
      {!isCollapsed && <span>Return home</span>}
    </Link>
  );
};

export default AdminSidebarReturnLink;
